import { siteInfo, heroHighlights } from "@/mocks/melons";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_15%_20%,oklch(var(--primary-100)/0.7),transparent_45%),radial-gradient(circle_at_90%_10%,oklch(var(--accent-100)/0.6),transparent_42%),radial-gradient(circle_at_50%_100%,oklch(var(--secondary-100)/0.5),transparent_50%)]" />
      <div className="mx-auto grid w-full max-w-[1200px] items-center gap-8 px-4 pb-10 pt-10 md:px-6 lg:grid-cols-[1.05fr_0.95fr] lg:pb-16 lg:pt-14">
        <div>
          <div className="flex flex-wrap items-center gap-2">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-100/70 px-3 py-1 text-xs font-medium text-primary-800">
              <i className="ri-fire-line" /> {siteInfo.edition}
            </span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border border-accent-200 bg-accent-100/70 px-3 py-1 text-xs font-medium text-accent-800">
              <i className="ri-eye-line" /> 直播围观中 · {siteInfo.liveViewers} 人
            </span>
          </div>

          <h1 className="mt-5 font-heading text-4xl leading-tight text-foreground-900 sm:text-5xl lg:text-[56px]">
            本月大瓜，全网热点
            <span className="mt-1 block text-primary-600">一网吃尽，边看边聊</span>
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-lg">
            {siteInfo.sub} 本期已聚集 <strong className="font-semibold text-accent-700">{siteInfo.hotComments}</strong>{" "}
            条网友评论与群众反应，等你来围观、来热议。
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#hot"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-600 px-6 py-3 text-base font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-fire-fill" /> 看今日热搜
            </a>
            <a
              href="#talk"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-base font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              <i className="ri-chat-3-line" /> 加入网友热议
            </a>
          </div>

          <dl className="mt-9 grid grid-cols-3 gap-4 border-t border-background-200/70 pt-5">
            {heroHighlights.map((h) => (
              <div key={h.label}>
                <dt className="text-xs text-foreground-600">{h.label}</dt>
                <dd className="mt-1 font-heading text-2xl text-foreground-900">{h.value}</dd>
              </div>
            ))}
          </dl>
        </div>

        <div className="relative">
          <div className="relative overflow-hidden rounded-[28px] shadow-soft">
            <img
              src="https://readdy.ai/api/search-image?query=a%20cheerful%20cartoon%20watermelon%20mascot%20sitting%20in%20the%20center%20of%20a%20lively%20social%20discussion%2C%20surrounded%20by%20floating%20speech%20bubbles%20with%20question%20marks%20and%20heart%20and%20fire%20symbols%2C%20flat%20pop%20editorial%20illustration%2C%20fresh%20green%20melon%20skin%20and%20coral%20red%20flesh%20colors%2C%20warm%20cream%20background%2C%20playful%20gossip%20news%20vibe%2C%20high%20detail%2C%20no%20text&width=860&height=760&seq=hero-illustration&orientation=portrait"
              alt="本月大瓜围观现场的卡通西瓜吉祥物与讨论气泡插画"
              className="h-full w-full object-cover"
            />
          </div>
          <div className="absolute -left-3 top-6 flex items-center gap-2 rounded-full border border-background-200 bg-background-50/95 px-3 py-2 text-xs font-medium text-foreground-800 shadow-soft md:-left-6">
            <span className="flex h-6 w-6 items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-arrow-up-line" />
            </span>
            热议 +12%
          </div>
          <div className="absolute -right-2 bottom-8 flex items-center gap-2 rounded-full border border-background-200 bg-background-50/95 px-3 py-2 text-xs font-medium text-foreground-800 shadow-soft md:-right-4">
            <i className="ri-refresh-line text-accent-600" />
            群众反应 · 更新中
          </div>
        </div>
      </div>
    </section>
  );
}